// UTM Attribution Tracker
// Captures utm_* params on first landing, persists for 30 days, and exposes the
// stored attribution to checkout so we can measure ROAS per campaign/source.

const STORAGE_KEY = 'ckm_utm';
const TTL_DAYS = 30;
const FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export function captureUtmFromUrl() {
  if (typeof window === 'undefined') return null;
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    FIELDS.forEach((k) => {
      const v = params.get(k);
      if (v) found[k] = v.slice(0, 120);
    });
    // Only overwrite if at least one utm param is present in this URL — preserves first-touch otherwise.
    if (Object.keys(found).length === 0) return getStoredUtm();

    // Add referrer + capture time for analytics context
    if (document.referrer && !document.referrer.includes(window.location.host)) {
      found.referrer = document.referrer.slice(0, 200);
    }
    const payload = { ...found, _ts: Date.now() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    return payload;
  } catch (_e) {
    return null;
  }
}

export function getStoredUtm() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const ageMs = Date.now() - (parsed._ts || 0);
    if (ageMs > TTL_DAYS * 24 * 60 * 60 * 1000) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    const { _ts: _ignored, ...rest } = parsed;
    return rest;
  } catch (_e) {
    return null;
  }
}

export function clearStoredUtm() {
  try { localStorage.removeItem(STORAGE_KEY); } catch (_e) { /* no-op */ }
}
